import axios from 'axios';
import { createSignedPatchRequest } from 'utils/createSignedRequestsHelpers';

export const patchUpdateCard = async ({
  cardId,
  cardData,
  activeEmployerInfo,
}) => {
  const apiPath = `cards/card/${cardId}/update-card`;

  const signedRequest = await createSignedPatchRequest({
    apiPath,
    body: { cardAttributes: cardData },
    activeEmployerInfo,
  });

  const response = await axios(signedRequest);

  return response.data;
};
